import React, { useContext, useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { ReactSession } from "react-client-session";
import warn from "../../../assets/warning.svg";
import useAxiosPrivate from "../../../hooks/useAxiosPrivate";
import VideoContext from "../../../context/VideoContext";
import FormContext from "../../../context/FormContext";
import "./ScanScreen.css";
import { getSuccessToast, getErrorToast } from "../../../toast";
import HotkeysHandler from "../../../hooks/HotkeysHandler";
import { toast } from "react-toastify";
// import { BlobServiceClient } from "@azure/storage-blob";
import cv from "@techstark/opencv-js";
import { returnTypeFinder, isReturnTypeDisabled } from "../../../constants.js";
import { Autocomplete, TextField, Box, Select, MenuItem } from "@mui/material";

window.cv = cv;

const GOOGLE_API = process.env.REACT_APP_GOOGLE_API_URL;
const containerName = process.env.REACT_APP_CONTAINER_NAME;
const sasToken = process.env.REACT_APP_SAS_TOKEN;
const storageAccountName = process.env.REACT_APP_STORAGE_ACCOUNT_NAME;
let streamTrack;

const ScanScreen = () => {
  const { videoFeed, setVideoFeed } = useContext(VideoContext);
  const { setIsFormOpen } = useContext(FormContext);
  const [videoStream, setVideoStream] = useState("");
  const [Video, setVideo] = useState("");
  const [batchNumber, setBatchNumber] = useState("");
  const [medicineArr, setMedicineArr] = useState([]);
  const [disableAC, setDisableAC] = useState(false);
  const [displayMsg, setDisplayMsg] = useState(false);
  const [options, setOptions] = useState([]);
  const [recentEntriesData, setRecentEntriesData] = useState([]);
  const [refreshEntriesData, setRefreshEntriesData] = useState(0);
  const [medicineId, setMedicineId] = useState(null);
  const [message, setMessage] = useState("");
  const [returnType, setReturnType] = useState({
    value: "",
    disabled: true,
    returnOptions: [],
  });

  const unitsRef = useRef();
  const descInputRef = useRef();
  const MrpInputRef = useRef();
  const ProductCodeInputRef = useRef();
  // const expiryRef = useRef();
  // const checkedRef = useRef();
  const axiosPrivate = useAxiosPrivate();
  const navigate = useNavigate();

  const boxId = ReactSession.get("box_id");
  const variix = ReactSession.get("varii");
  const mog = ReactSession.get("mog");
  // const uploadToBlob = async (file) => {
  //   if (!file) return [];

  //   const blobService = new BlobServiceClient(
  //     `https://${storageAccountName}.blob.core.windows.net/?${sasToken}`
  //   );

  //   const containerClient = blobService.getContainerClient(containerName);

  //   const blobClient = containerClient.getBlockBlobClient(file.name);

  //   const options = { blobHTTPHeaders: { blobContentType: file.type } };

  //   await blobClient.uploadData(file, options);
  // };

  const convertBase64ToFile = (dataurl, filename) => {
    var arr = dataurl.split(","),
      mime = arr[0].match(/:(.*?);/)[1],
      bstr = atob(arr[1]),
      n = bstr.length,
      u8arr = new Uint8Array(n);

    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }

    return new File([u8arr], filename, { type: mime });
  };

  const startVideo = () => {
    navigator.getUserMedia(
      {
        audio: false,
        video: {
          // deviceId: mycamera,
          width: { ideal: 3840 }, //2592
          height: { ideal: 2160 }, //1944
        },
        facingMode: "environment",
        aspectRatio: { exact: 1.5777777778 },
      },
      (stream) => {
        streamTrack = stream.getVideoTracks()[0];
        setVideoStream(stream);
        let video = document.querySelector(".video-feed");
        video.width = 2592; //500
        video.height = 1944; //350
        if (video) {
          video.srcObject = stream;
          video.play();
          setVideo(video);
        }
        //
        let fgbg = new cv.BackgroundSubtractorMOG2(parseInt(mog), 16, true);
        let fg_mask = new cv.Mat(video.height, video.width, cv.CV_8UC1);

        let src = new cv.Mat(video.height, video.width, cv.CV_8UC4);
        let src_2 = new cv.Mat(video.height, video.width, cv.CV_8UC4);
        let crop_img = new cv.Mat(video.height, video.width, cv.CV_8UC4);

        let dst = new cv.Mat(video.height, video.width, cv.CV_8UC1);

        // let re_dsize = new cv.Size(375, 150);
        let re_showsize = new cv.Size(500, 350);
        let cap = new cv.VideoCapture(video);

        function variance(img) {
          let myMean = new cv.Mat(1, 4, cv.CV_64F);
          let myStddev = new cv.Mat(1, 4, cv.CV_64F);
          cv.meanStdDev(img, myMean, myStddev);
          let std = myStddev.doubleAt(0, 0);

          let para = std * std;
          return para;
        }

        let x_min = 648; //125
        let y_min = 486; //47
        let width = 1296; //250
        let height = 486; //100

        // let p1 = new cv.Point(125, 67);
        // let p2 = new cv.Point(125 + 250, 67 + 100);
        let rect_interest = new cv.Rect(x_min, y_min, width, height);

        const FPS = 30;
        let flag = true;
        let flag_first_frame_check = true; // This flag is to check whether user has kept any object on the platform after switching on the camera for the first time.
        let frame_count = 0;
        let frame_count_check = 1;
        let flag_og_frame_vari = false;

        async function processVideo() {
          try {
            let begin = Date.now();
            // start processing.
            cap.read(src);

            cv.resize(src, src_2, re_showsize, 0, 0, cv.INTER_CUBIC); //change

            cv.cvtColor(src_2, dst, cv.COLOR_RGBA2GRAY, 0);
            cv.threshold(dst, dst, 75, 255, cv.THRESH_BINARY);

            fgbg.apply(src_2, fg_mask); //Applying Mixture of Gaussian Background Subtraction on src and save it in fg_mask canvas

            let varii = variance(fg_mask); //Calculate the variance of fg_mask canvas.
            let og_frame_varii = variance(dst); //Caculate the variance of thresholded image dst.
            //Looping over Contours

            // let contour_count = 0;
            if (frame_count < frame_count_check) {
              frame_count = frame_count + 1;
              if (og_frame_varii > 850) {
                // This condition is True if any object is present inside the box on the 4th frame after video is started.
                toast.warn(
                  "PLEASE CLEAR THE TRAY BEFORE SCANNING FOR THE FIRST TIME!",
                  {
                    theme: "colored",
                    position: "top-right",
                    autoClose: 2000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: false,
                    draggable: true,
                    progress: undefined,
                  }
                );
                flag_first_frame_check = false;
                flag_og_frame_vari = true;
                frame_count = frame_count_check;
              } else {
                if (frame_count_check < 10) {
                  frame_count_check += 1;
                }
              }
            }

            if (flag_og_frame_vari == true) {
              if (og_frame_varii < 1800) {
                flag_first_frame_check = true;
                toast.success("TRAY CLEARED!! READY TO SCAN!!", {
                  theme: "colored",
                  position: "top-right",
                  autoClose: 1000,
                  hideProgressBar: true,
                  closeOnClick: true,
                  pauseOnHover: false,
                  draggable: true,
                  progress: undefined,
                });
                flag_og_frame_vari = false;
              }
            }
            //Loop over the contours
            if (flag === true) {
              let EmptyArrayFlag = true;
              // if (varii < 800) {
              if (varii < parseInt(variix)) {
                if (flag_first_frame_check == true && og_frame_varii > 850) {
                  let image_data = "";
                  let blob_flag = true;
                  let blob_url = "";
                  crop_img = src.roi(rect_interest);

                  cv.rotate(crop_img, crop_img, cv.ROTATE_180);

                  // You can try more different parameters

                  cv.imshow("canvas", crop_img);
                  let canvas = document.querySelector("#canvas");

                  if (EmptyArrayFlag === true) {
                    setDisableAC(true);
                    setMedicineArr([]);
                  }
                  EmptyArrayFlag = false;
                  flag = false;
                  let image_data_url = canvas.toDataURL("image/jpeg");
                  image_data = image_data_url;
                  if (image_data !== "" && blob_flag) {
                    // var today = new Date();
                    // let date =
                    //   today.getFullYear() +
                    //   "-" +
                    //   (today.getMonth() + 1) +
                    //   "-" +
                    //   today.getDate();
                    // let time =
                    //   today.getHours() +
                    //   ":" +
                    //   today.getMinutes() +
                    //   ":" +
                    //   today.getSeconds();
                    // let randomNumber = Math.floor(
                    //   100000 + Math.random() * 900000
                    // );
                    var file_scan_image = convertBase64ToFile(
                      image_data,
                      `image.jpeg`
                    );
                    // uploadToBlob(file_scan_image);
                    // blob_url = `https://${storageAccountName}.blob.core.windows.net/${containerName}/capture_image_${date}_${time}_${randomNumber}.jpeg`;
                    blob_flag = false;
                  }

                  setBatchNumber("");
                  setOptions([]);
                  descInputRef.current.value = "";
                  ProductCodeInputRef.current.value = "";
                  unitsRef.current.value = "";
                  MrpInputRef.current.value = "";
                  setReturnType({
                    value: "",
                    disabled: true,
                    returnOptions: [],
                  });
                  setMedicineId(null);
                  try {
                    const req = async () => {
                      const reqTime = console.time();
                      const payload = new FormData();
                      payload.append("image", file_scan_image);
                      // payload.append("blob_url", blob_url);
                      const backRes = await axiosPrivate.post(
                        `/data_entry/ai_entry/${boxId}/`,
                        payload
                      );

                      let optionTempArr = [];
                      if (!Array.isArray(backRes.data)) {
                        if (backRes.data.result === "None similarity found") {
                          toast.warn("No text detected please Scan Again!", {
                            theme: "colored",
                            position: "top-right",
                            autoClose: 2000,
                            hideProgressBar: true,
                            closeOnClick: true,
                            pauseOnHover: false,
                            draggable: true,
                            progress: undefined,
                          });
                          setDisableAC(false);
                        }

                        setMessage(
                          `No match found, please type the batch number!`
                        );

                        setOptions([]);
                        setDisableAC(false);
                        setTimeout(() => {
                          document.getElementById("batch-number").focus();
                        });
                      } else {
                        setRefreshEntriesData((prev) => prev + 1);
                        const tempArr = [];
                        setMedicineArr(backRes.data);
                        backRes.data.forEach((ele) => {
                          tempArr.push({
                            label: ele.batch_number,
                            batch_number: ele.batch_number,
                            description: ele.description,
                            material: ele.material,
                            units: 1,
                            mrp: ele.mrp,
                            goods_type: ele.goods_type,
                            cold_storage: ele.cold_storage,
                          });
                        });
                        setDisableAC(false);
                        setOptions(tempArr);
                        setBatchNumber(backRes.data[0]["batch_number"]);
                        descInputRef.current.value =
                          backRes.data[0]["description"];
                        ProductCodeInputRef.current.value =
                          backRes.data[0]["material"];

                        unitsRef.current.value = backRes.data[0]["quantity"];
                        MrpInputRef.current.value = backRes.data[0]["mrp"];
                        // expiryRef.current.value = backRes.data[0]["goods_type"];
                        setReturnType({
                          value: backRes.data[0]["goods_type"],
                          disabled: isReturnTypeDisabled(
                            backRes.data[0]["goods_type"],
                            backRes.data[0]["cold_storage"]
                          ),
                          returnOptions: returnTypeFinder(
                            backRes.data[0]["goods_type"],
                            backRes.data[0]["cold_storage"]
                          ),
                        });
                        setMedicineId(
                          backRes.data[0]["box_medicine_data_master_id"]
                        );

                        if (backRes.data[0].box_medicine_data_master_id) {
                          unitsRef.current.focus();
                          unitsRef.current.select();

                          toast.success("Data saved successfully", {
                            theme: "colored",
                            position: "top-right",
                            autoClose: 1000,
                            hideProgressBar: true,
                            closeOnClick: true,
                            pauseOnHover: false,
                            draggable: true,
                            progress: undefined,
                          });
                        } else {
                          toast.error(
                            "Medicine not scanned! Please scan the medicine again!",
                            {
                              theme: "colored",
                              position: "top-right",
                              autoClose: 1500,
                              hideProgressBar: true,
                              closeOnClick: true,
                              pauseOnHover: false,
                              draggable: true,
                              progress: undefined,
                            }
                          );
                        }

                        if (
                          backRes.data[0]["score"] <= 100 &&
                          backRes.data.length > 1
                        ) {
                          setMessage(
                            `Multiple matches found, kindly verify the batch number`
                          );
                        } else if (
                          backRes.data[0]["score"] < 100 &&
                          backRes.data.length === 1
                        ) {
                          setMessage(`Kindly verify the batch number`);
                        }

                        console.timeEnd(reqTime);

                        setMedicineArr((oldArr) => [
                          ...oldArr,
                          backRes.data[0],
                        ]);
                      }
                      setDisplayMsg(true);
                    };
                    req();
                  } catch (error) {
                    console.log(error);
                  }
                }
              }
            }
            if (flag == 0) {
            }

            if (og_frame_varii < 850) {
              flag = true;
            }

            let delay = 1000 / FPS - (Date.now() - begin);
            if (ReactSession.get("videoFeedStatus")) {
              setTimeout(processVideo, delay);
            } else {
              return;
            }
          } catch (err) {
            console.error(err);
          }
        }

        // schedule the first one.
        setTimeout(processVideo, 0);
        if (!ReactSession.get("videoFeedStatus")) {
          src.delete();
          dst.delete();
        }
      },
      (err) => console.error(err)
    );
  };

  const stopVideo = () => {
    let video = document.querySelector(".video-feed");
    const tracks = video.srcObject.getTracks();
    tracks.forEach((track) => track.stop());
  };

  useEffect(() => {
    return () => {
      streamTrack?.stop();
      ReactSession.set("videoFeedStatus", false);
      setVideoFeed(false);
      setRecentEntriesData([]);
    };
  }, []);

  useEffect(() => {
    if (boxId) {
      axiosPrivate.get(`/dashboard/boxdetails/${boxId}/3`).then((res) => {
        setRecentEntriesData(res.data.data.slice(0, 3));
      });
    }
  }, [refreshEntriesData]);

  useEffect(() => {
    if (videoFeed) {
      ReactSession.set("videoFeedStatus", true);
      startVideo();
    } else if (Video !== "" && !videoFeed) {
      ReactSession.set("videoFeedStatus", false);
      stopVideo();
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [videoFeed]);

  const resetHandler = (index, id) => {
    if (medicineId) {
      axiosPrivate
        .delete("/data_entry/update_entry/", {
          data: {
            box_medicine_data_master_id: medicineId,
          },
        })
        .then((res) => {
          if (res.status === 204) {
            setRefreshEntriesData((prev) => prev + 1);
            setBatchNumber("");
            setOptions([]);
            descInputRef.current.value = "";
            ProductCodeInputRef.current.value = "";
            unitsRef.current.value = "";
            MrpInputRef.current.value = "";
            setReturnType({
              value: "",
              disabled: false,
              returnOptions: [],
            });
            setMedicineId(null);

            toast.success("Entry deleted successfully", {
              theme: "colored",
              position: "top-right",
              autoClose: 1000,
              hideProgressBar: true,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
            });
          }
        });
    } else {
      return;
    }
  };

  const existingBox = () => {
    navigate("/stockist-report");
  };

  const addNewBox = () => {
    setIsFormOpen(true);
    navigate("/operator");
  };

  const updateMedicineData = (index, id) => {
    // const reg = new RegExp(/^\d+(\.\d{1,2})?$/);
    const reg = new RegExp("[1-9]+[0-9]{0,}");

    if (batchNumber.length === 0 || descInputRef.current.value === "") {
      getErrorToast("Please select a batch number from the dropdown");
      return;
    }

    if (unitsRef.current.value === "0" || !reg.test(unitsRef.current.value)) {
      getErrorToast("Unit cannot be 0");
      return;
    }

    if (unitsRef.current.value === undefined || unitsRef.current.value == "") {
      getErrorToast("Unit is required.");
      return;
    }

    if (unitsRef.current.value <= "0") {
      getErrorToast("Unit can't negative.");
      return;
    }
    let data = {
      quantity: unitsRef.current.value,
      box_medicine_data_master_id: medicineId,
      batch_number: batchNumber,
      description: descInputRef.current.value,
      material: ProductCodeInputRef.current.value,
      goods_type: returnType.value,
      mrp: MrpInputRef.current.value,
    };

    if (medicineId) {
      axiosPrivate
        .patch("/data_entry/update_entry/", data)
        .then((res) => {
          console.log("%cCLEAR MESSAGE", "font-size: 40px");
          setMessage("");
          setRefreshEntriesData((prev) => prev + 1);
          toast.success("Entry updated successfully", {
            theme: "colored",
            position: "top-right",
            autoClose: 1000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
        })
        .catch((err) => {
          toast.error(err, {
            theme: "colored",
            position: "top-right",
            autoClose: 1000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
        });
    } else {
      data = {
        batch_number: batchNumber,
        description: descInputRef.current.value.trim(),
        quantity: unitsRef.current.value,
        predicted_text: "test_string",
        by_ai: false,
        created_by: 1,
        updated_by: 1,
        stockists_master: ReactSession.get("box_id"),
        goods_type: returnType.value,
        mrp: MrpInputRef.current.value,
      };
      axiosPrivate
        .post("/data_entry/ai_select_entry/", data)
        .then((res) => {
          if (res.status === 201) {
            console.log("%cCLEAR MESSAGE", "font-size: 40px");
            setMessage("");
            setRefreshEntriesData((prev) => prev + 1);
            setMedicineId(res.data["box_medicine_data_master_id"]);
            getSuccessToast("Medicine added successfully", 2000);
          }
        })
        .catch((err) => {
          toast.error(err, {
            theme: "colored",
            position: "top-right",
            autoClose: 1000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
        });
    }
  };
  const editUnitsHandler = (e) => {
    if (e != null) {
    }
  };
  const editMedicinehandler = (e, newValue) => {
    if (newValue != null && e != null) {
      setBatchNumber(newValue["batch_number"]);
      descInputRef.current.value = newValue["description"];
      ProductCodeInputRef.current.value = newValue["material"];
      unitsRef.current.value = newValue["units"];
      MrpInputRef.current.value = newValue["mrp"];
      setReturnType({
        value: newValue["goods_type"],
        disabled: isReturnTypeDisabled(
          newValue["goods_type"],
          newValue["cold_storage"]
        ),
        returnOptions: returnTypeFinder(
          newValue["goods_type"],
          newValue["cold_storage"]
        ),
      });
      // expiryRef.current.value = newValue["goods_type"];
      unitsRef.current.focus();
    }
    return;
  };

  const optionChange = async (e, newValue) => {
    if (newValue.length === 0) {
      setBatchNumber("");
      descInputRef.current.value = "";
      ProductCodeInputRef.current.value = "";
      unitsRef.current.value = "";
      MrpInputRef.current.value = "";
      setReturnType({
        value: "",
        disabled: true,
        returnOptions: [],
      });
      setOptions([]);
      unitsRef.current.focus();
    }

    setBatchNumber(newValue);
    if (e != null && newValue != null) {
      if (newValue.length <= 2) {
        return;
      }
      const res = await axiosPrivate.get(
        `/data_entry/batch_number/?search=${newValue}`
      );
      const index = parseInt(e.target.id.split("-")[1]);
      let tempArr = [];
      const optionArr = [...options];
      res.data.forEach((ele) => {
        tempArr.push({
          label: ele.batch_number,
          batch_number: ele.batch_number,
          description: ele.description,
          material: ele.material,
          units: 1,
          mrp: ele.mrp,
          goods_type: ele.goods_type,
          cold_storage: ele.cold_storage,
        });
      });
      setOptions(tempArr);
    }
  };

  function formatDate(date) {
    var d = new Date(date),
      month = "" + (d.getMonth() + 1),
      day = "" + d.getDate(),
      year = d.getFullYear();
    if (month.length < 2) month = "0" + month;
    if (day.length < 2) day = "0" + day;
    return [day, month, year].join("-");
  }

  const handlerReason = (event) => {
    setReturnType((prev) => ({
      ...prev,
      value: event.target.value,
    }));
  };

  return boxId ? (
    <React.Fragment>
      <div className="main-screen-container">
        <h3 className="warn-message">
          <span className="warn-icon">
            <img
              src={warn}
              style={{
                display: `${message !== "" ? "inline" : "none"}`,
              }}
              alt=""
            />
          </span>
          {message}
        </h3>
        <HotkeysHandler
          keys="shift+alt+c"
          handler={() => {
            setVideoFeed((prev) => !prev);
          }}
        />
        <div className="main-screen-container-1">
          <h1 className="main-screen-container-1-heading">Live Feed</h1>
          <div className="main-screen-container-1-camera-container">
            <video
              className="video-feed"
              // style={{ display: "none" }}
              id="feed"
            ></video>
            {videoFeed && <div className="box"></div>}
          </div>
        </div>

        <div className="main-screen-container-2">
          <h1 className="main-screen-container-2-heading">Captured Image</h1>
          <div className="main-screen-container-2-camera-container">
            <canvas
              id="canvas_test"
              width="500"
              height="350"
              style={{ display: "none" }}
            ></canvas>

            <canvas
              id="canvas"
              width="500"
              height="350"
              style={{
                backgroundColor: "black",
                borderRadius: "10px",
                width: "100%",
                height: "100%",
              }}
            ></canvas>
          </div>
        </div>

        <div className="main-screen-container-3">
          <h6 className="main-screen-container-3-header">Drug Information</h6>
          <div className="main-screen-container-3-labels">
            <label className="scan-container-data-lbls">Batch</label>
            <label className="scan-container-data-lbls">
              Material Description
            </label>
            <label className="scan-container-data-lbls">Material Code</label>
            <label className="scan-container-data-lbls">Quantity</label>
            <label className="scan-container-data-lbls">MRP</label>
            <label className="scan-container-data-lbls">Expiry Status</label>
            <label className="scan-container-data-lbls scan-container-lbl-s">
              Status
            </label>
            <label className="scan-container-data-lbls">Actions</label>
          </div>

          <div className="main-screen-container-3-fields">
            <div className="container-3-ip-wr">
              {
                <Autocomplete
                  className="scan-details-input"
                  value={batchNumber}
                  disabled={disableAC}
                  disablePortal
                  selectOnFocus={false}
                  clearOnBlur={false}
                  options={options}
                  defaultValue={options[0]}
                  id="batch-number"
                  renderOption={(props, options) => (
                    <Box
                      component="li"
                      sx={{
                        "& > img": { mr: 2, flexShrink: 0 },
                        overflow: "hidden",
                      }}
                      {...props}
                    >
                      {options["batch_number"]} {options["description"]}{" "}
                      {options["mrp"]}
                    </Box>
                  )}
                  onChange={(e, newValue) => {
                    editMedicinehandler(e, newValue);
                  }}
                  onInputChange={(event, newValue) => {
                    optionChange(event, newValue);
                  }}
                  sx={{
                    width: "15vw",
                    textTransform: "uppercase",
                    "& .css-1krl8tb-MuiFormControl-root-MuiTextField-root": {
                      height: "1.75em",
                    },
                    "& .MuiAutocomplete-hasPopupIcon.css-13xad1h-MuiAutocomplete-root .MuiOutlinedInput-root, .MuiAutocomplete-hasClearIcon.css-13xad1h-MuiAutocomplete-root .MuiOutlinedInput-root":
                      {
                        height: "1.75em",
                      },
                    "& .css-14s5rfu-MuiFormLabel-root-MuiInputLabel-root": {
                      fontWeight: "600",
                      top: "-8px",
                      fontSize: "0.65em",
                    },
                    "& .MuiOutlinedInput-root": {
                      height: "1.75em",
                    },
                    "& .css-qzbt6i-MuiButtonBase-root-MuiIconButton-root-MuiAutocomplete-popupIndicator":
                      {
                        display: "none",
                      },
                    "& .MuiAutocomplete-input": {
                      position: "absolute",
                      width: "80% !important",
                    },
                    '&[data-focus="false"]': {
                      backgroundColor: "transparent",
                      borderColor: "transparent",
                    },
                    '&[aria-selected="false"]': {
                      borderColor: "transparent",
                    },
                  }}
                  renderInput={(params) => (
                    <TextField
                      sx={{
                        fontSize: "1em",
                        height: "1.75em",
                        padding: 0,
                      }}
                      {...params}
                    />
                  )}
                />
              }
            </div>
            <div className="container-3-ip-wr">
              <input
                disabled
                placeholder="Material Description"
                className="disabled container-3-ip container-3-ip-3 scan-details-input"
                type="text"
                ref={descInputRef}
                onChange={(e) => editMedicinehandler(e)}
              />
            </div>
            <div className="container-3-ip-wr">
              <input
                placeholder="Material Code"
                className="disabled container-3-ip container-3-ip-3 scan-details-input"
                type="text"
                disabled
                ref={ProductCodeInputRef}
                onChange={(e) => editMedicinehandler(e)}
              />
            </div>
            <div className="container-3-ip-wr">
              <input
                placeholder="Quantity"
                disabled={disableAC}
                className="container-3-ip container-3-ip-2 scan-details-input"
                type="number"
                onChange={(e) => editUnitsHandler(e)}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    updateMedicineData();
                  }
                }}
                id="quantity"
                ref={unitsRef}
              />
            </div>

            <div className="container-3-ip-wr">
              <input
                readOnly
                disabled
                placeholder="MRP"
                className="disabled container-3-ip container-3-ip-2 scan-details-input"
                type="number"
                onChange={(e) => editMedicinehandler(e)}
                ref={MrpInputRef}
                id="mrp"
              />
            </div>

            <div className="container-3-ip-wr">
              <Select
                labelId="dropdown-label"
                id="dropdown"
                value={returnType.value}
                onChange={handlerReason}
                sx={{ width: 200, height: 32 }}
                disabled={returnType.disabled}
                required
              >
                {returnType.returnOptions.map((item, index) => (
                  <MenuItem key={index} value={item}>
                    {item}
                  </MenuItem>
                ))}
              </Select>
            </div>

            <div className="container-3-input-wr container-3-status-wr">
              <p className="container-3-ip-status ">
                {medicineId ? "✅" : "❌"}
              </p>
            </div>
            <div className="container-3-ip-wr container-3-btn-wr">
              <button
                onClick={() => updateMedicineData()}
                className="container-3-btn container-3-update-btn"
                disabled={disableAC}
              >
                Update
              </button>

              {medicineId ? (
                <button
                  onClick={() => resetHandler()}
                  className="container-3-btn container-3-delete-btn"
                >
                  Delete
                </button>
              ) : (
                <button
                  disabled
                  className="container-3-btn container-3-delete-btn"
                >
                  Delete
                </button>
              )}
            </div>
          </div>
          <h6 className="main-screen-container-3-header">Recent Entries</h6>
          <div className="main-screen-container-3-table-container">
            <table style={{ marginTop: "0.5rem" }}>
              {/* <table style={{ marginTop: "1.75rem" }}> */}
              <thead>
                <tr>
                  <th>BATCH</th>
                  <th>Material Description</th>
                  <th>Material CODE</th>
                  <th>QUANTITY</th>
                  <th>MRP</th>
                  <th>EXPIRY STATUS</th>
                  <th>MFG DATE </th>
                  <th>EXPIRY DATE</th>
                  <th>DATE</th>
                </tr>
              </thead>
              <tbody>
                {recentEntriesData.map((row) => (
                  <tr
                    key={row.box_medicine_data_master_id}
                    className="ss-recent-entries-table-row"
                  >
                    <td>{row.medicine_master__batch_number}</td>
                    <td>{row.medicine_master__description}</td>
                    <td>{row.medicine_master__material}</td>
                    <td>{row.quantity}</td>
                    <td>{row.medicine_master__mrp}</td>
                    <td>{row.goods_type}</td>
                    <td>{row.medicine_master__manufacture_date}</td>
                    <td>{row.medicine_master__date_of_expiry}</td>
                    <td>{formatDate(row.created_on)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </React.Fragment>
  ) : (
    <div className="main-screen-container">
      <div className="delete-modal">
        <div className="delete-modal-desc">
          <p className="delete-modal-desc-para dmdp-1">
            Please add a new claim or enter into a existing claim!
          </p>
        </div>
        <div className="delete-modal-btns">
          <button onClick={existingBox} className="box-complete-btn" id="yes">
            Enter in a existing claim
          </button>
          <button
            onClick={addNewBox}
            className="{/*delete-modal-btn*/} box-complete-btn"
            id="no"
          >
            Add a new claim!
          </button>
        </div>
      </div>
    </div>
  );
};

export default ScanScreen;
